import Swiper, {Navigation, Pagination, Lazy} from "swiper";
Swiper.use([Navigation, Pagination, Lazy]);

const initCompletingSlider = () => {
  const sliderContainer = document.querySelector("[data-completing-slider]");
  sliderContainer && new Swiper(sliderContainer, {
    lazy: true,
    spaceBetween: 16,
    breakpoints: {
      997: {
      slidesPerView: 3,
      },    
      768: {
        slidesPerView: 2,
      },       
      0: {
        slidesPerView: 1,
      },
    },
    pagination: {
      el: "[data-completing-slider-container] .swiper-pagination",
      clickable: true,
      bulletElement: "button",
    },
    navigation: {
      nextEl: "[data-completing-slider-container] .slider-navigation__button--next",
      prevEl: "[data-completing-slider-container] .slider-navigation__button--prev",
    },
  });  
};

export default initCompletingSlider;
